var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-hierarchical-menu',{attrs:{"attributes":[_vm.attribute + '.lvl0', _vm.attribute + '.lvl1'],"limit":200,"class-names":{
    'ais-HierarchicalMenu': 'menu-list',
    'ais-HierarchicalMenu-count': 'tag level-item is-justify-content-flex-end',
    'ais-HierarchicalMenu-item--active': 'has-text-weight-bold',
    'ais-HierarchicalMenu-link': 'level is-mobile',
    'ais-HierarchicalMenu-label': 'level-item is-justify-content-flex-start is-flex-shrink-1',
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }